module.exports = __webpack_public_path__ + "static/media/h.7c730d06.png";